import axios from 'axios';

/**
 * Login Activity Service
 *
 * Handles API requests for login activity and User Location Map feature.
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

/**
 * Map data point interface (matches backend)
 */
export interface MapDataPoint {
  id: string;
  user_id: string;
  user_name: string;
  user_email: string;
  company_id: string;
  company_name: string;
  latitude: number;
  longitude: number;
  city: string;
  region: string;
  country: string;
  country_code: string;
  login_timestamp: string;
  user_agent: string | null;
}

/**
 * Map statistics interface
 */
export interface MapStats {
  total_logins_with_location: number;
  unique_countries: number;
  unique_users: number;
  most_recent_login: string | null;
}

/**
 * Get map data for visualization
 * Returns all login locations for the map
 * Platform Admin only
 * @param token - JWT authentication token
 * @param days - Optional filter for last N days (1, 7, 30, 90, or undefined for all time)
 */
export async function getMapData(token: string, days?: number): Promise<MapDataPoint[]> {
  const params: any = {};
  if (days !== undefined) {
    params.days = days;
  }

  const response = await axios.get(`${API_BASE_URL}/login-activity/map-data`, {
    headers: {
      Authorization: `Bearer ${token}`
    },
    params
  });
  return response.data.data;
}

/**
 * Get map statistics
 * Returns aggregate stats for the map dashboard
 * Platform Admin only
 * @param token - JWT authentication token
 * @param days - Optional filter for last N days (1, 7, 30, 90, or undefined for all time)
 */
export async function getMapStats(token: string, days?: number): Promise<MapStats> {
  const params: any = {};
  if (days !== undefined) {
    params.days = days;
  }

  const response = await axios.get(`${API_BASE_URL}/login-activity/map-stats`, {
    headers: {
      Authorization: `Bearer ${token}`
    },
    params
  });
  return response.data.data;
}

const loginActivityService = {
  getMapData,
  getMapStats
};

export default loginActivityService;
